import React, { useState } from "react";
import { Link, useNavigate, useSearchParams } from "react-router-dom";
import Logo from "../components/Logo";
import { loginUser } from "../lib/auth";
import { useAuth } from "../context/AuthContext";

export default function Login() {
  const [searchParams] = useSearchParams();
  const [email, setEmail] = useState(searchParams.get("email") || "");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const navigate = useNavigate();
  const { setUser } = useAuth();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");

    if (!email || !password) {
      setError("Please enter your email and password.");
      return;
    }

      const loginRes = await loginUser(email, password);
      if (!loginRes) {
        setError("Invalid email or password.");
        return;
      }

      const meRes = await fetch("/api/me", {
        headers: { Authorization: `Bearer ${loginRes.token}` }
      });

      if (!meRes.ok) {
        setError("Failed to load user.");
        return;
      }

      const me = await meRes.json();
      setUser(me);

      if (me.role === "admin" || me.role === "owner") {
        navigate("/admin/dashboard");
      } else {
        navigate("/dashboard");
      }
  };

  return (
    <div className="min-h-screen bg-gradient-hero text-white flex flex-col">
      <div className="px-6 md:px-12 pt-7 flex items-center justify-between">
        <Logo size="sm" />
        <Link to="/" className="text-xs text-white/50 hover:text-white">
          Back home
        </Link>
      </div>

      <div className="flex-1 grid place-items-center px-6 md:px-12 py-10">
        <div className="w-full max-w-md glass-strong rounded-3xl p-8 md:p-10">
          <div className="text-[11px] tracking-[0.28em] uppercase text-[#D4AF37] mb-3">
            Sign in
          </div>

          <h1 className="font-display text-4xl leading-tight">
            Welcome back.
          </h1>

          <p className="text-white/55 mt-3">
            Sign in to continue your BoraMoyo journey.
          </p>

          <form onSubmit={handleSubmit} className="mt-6 space-y-4">
            <input
              type="email"
              placeholder="Email"
              className="w-full px-4 py-3 rounded-xl bg-white/10 border border-white/20 focus:outline-none"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
            />

            <input
              type="password"
              placeholder="Password"
              className="w-full px-4 py-3 rounded-xl bg-white/10 border border-white/20 focus:outline-none"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
            />

            {error && (
              <div className="text-red-400 text-sm">{error}</div>
            )}

            <button
              type="submit"
              className="w-full py-3 rounded-xl bg-[#D4AF37] text-black font-semibold"
            >
              Sign In
            </button>
          </form>

          <p className="text-sm text-white/60 mt-6">
            Don’t have an account?{" "}
            <Link to="/onboarding" className="text-[#F2DE94] hover:text-white">
              Get started
            </Link>
          </p>
          <p className="text-sm text-white/40 mt-3">
            <Link to={`/forgot-password?email=${encodeURIComponent(email)}`} className="hover:text-white/70">
              Forgot password?
            </Link>
          </p>
        </div>
      </div>
    </div>
  );
}
